module.exports = __webpack_public_path__ + "img/product-06.d686cd33.jpg";